import type { FC, ReactNode } from "react";

/** A titled card of rows: one section of key facts, or a group of switches. */
export const Group: FC<{ title: string; children: ReactNode }> = ({
  title,
  children
}) => (
  <section className="overflow-hidden rounded-xl bg-surface ring-1 ring-line-2">
    <h3 className="border-b border-line-1 bg-fill-1 px-4 py-2 text-sm font-medium text-fg-3">
      {title}
    </h3>
    <ul className="divide-y divide-line-1">{children}</ul>
  </section>
);
